import { FunctionComponent } from 'react';
import Image from 'next/image';

export interface HeaderProps {
  isTagVisible?: boolean;
  tag?: string;
  isTimerVisible?: boolean;
  minutes?: number;
  seconds?: number;
}

const Header: FunctionComponent<HeaderProps> = ({
  seconds = 0,
  minutes = 0,
  isTagVisible,
  tag = 'General',
  isTimerVisible = false,
}) => {
  const TIME_ICON_PATH = '/ielts/icons/time.png';
  const TIME_ICON_ALT = 'time icon';
  const TIME_ICON_SIZE = 40;

  return (
    <div className="w-full bg-white h-14 flex items-center fixed">
      <div className=" w-1/2 h-6 flex justify-between ml-20">
        {isTagVisible ? (
          <div className=" font-thin w-auto px-5 bg-gray-200 text-center p-1 text-xs rounded">
            <p>{tag}</p>
          </div>
        ) : (
          ''
        )}
        {isTimerVisible ? (
          <div className="w-auto mx-14 flex items-center">
            <Image
              src={TIME_ICON_PATH}
              alt={TIME_ICON_ALT}
              width={TIME_ICON_SIZE}
              height={TIME_ICON_SIZE}
            />
            <p className="font-light">
              {minutes <= 9 ? `0${minutes}` : minutes}:{seconds <= 9 ? `0${seconds}` : seconds}
            </p>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default Header;
